import { validator } from "LIB/validate-this";
import _ from "lodash";
import * as rules from "LIB/validation/rules";
import { validateShippingFields } from "MODULES/SalesOrders/components/shared/FormSections/ShippingSection/validate";
import {
  WARRANTY_CONSIDERATION,
  TEARDOWN
} from "MODULES/RepairOrders/constants";
import {
  COMPANY_ID,
  CONTACT_ID,
  EMAIL,
  NAME,
  PAYMENT_TERMS,
  SHIP_TO_FOB
} from "APP_ROOT/constants";
import { getCreditRequestedWarrantyRmas } from "MODULES/shared/helpers";
import {
  COMPANY,
  DROPSHIP
} from "MODULES/shared/components/ShippingSection/shippingTypes";

export const validRepairAssist = (val, values) => {
  if (!val) return undefined;
  if (
    _.get(
      values,
      "inventory.purchase_order_line_item.purchase_for_repair_assist"
    ) &&
    (_.isEmpty(_.get(values, "inventory.srp_condition")) ||
      _.isEmpty(_.get(values, "inventory.suggested_retail")))
  ) {
    return "Purchased For Repair Assist.  Please add Inventory SRP Condition and SRP before continuing.";
  }

  return undefined;
};

export const validReturnToForWarranty = (val, values) => {
  const creditRequestedRmas = getCreditRequestedWarrantyRmas(
    values.line_items,
    "inventory.most_recent_customer_rma"
  );

  const code = _.get(
    creditRequestedRmas,
    "[0].inventory.most_recent_customer_rma.code"
  );

  if (creditRequestedRmas.length > 0 && [COMPANY, DROPSHIP].includes(val)) {
    return `You must first remove the open credit request from Cust ${code} before you can return it to the Customer or an address other than our Store Location/s`;
  }

  return undefined;
};

export default function validate(values, props) {
  return validator(values, form => {
    form
      .validate(COMPANY_ID, CONTACT_ID, PAYMENT_TERMS, SHIP_TO_FOB)
      .satisfies(rules.required);

    if (values.contact_id === "Add") {
      form.validateChild("contact", contactForm => {
        contactForm.validate(EMAIL, NAME).satisfies(rules.required);
        contactForm.validate(EMAIL).satisfies(rules.isValidEmail);
      });
    }

    validateShippingFields("ship_to", values, form);

    if (
      values.line_items.some(i => i.action_requested === WARRANTY_CONSIDERATION)
    ) {
      form
        .validate("return_to_type")
        .satisfies(val => validReturnToForWarranty(val, values));
    }

    if (props.selectedCompany) {
      form
        .validate("company_id")
        .satisfies(() => rules.validateCompanyStatus(props.selectedCompany));
    }

    if (
      values.line_items.filter(i => i.action_requested === TEARDOWN).length > 1
    ) {
      form.validateChildren("line_items", item => {
        item
          .validate("action_requested")
          .satisfies(
            () =>
              "Please separate parts being sent for teardown to individual Repair Orders."
          );
      });
    }
  });
}



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/ConvertToRo/validate.js